<div class="content">
    <div>
        <div class="title"><img title="Error" alt="Error" src="assets/images/logo.svg" height="75"></div>
        <div class="header">Oops! We have encountered an error.</div>
        <div class="detail">{{ message }}</div>
    </div>
</div>
